import React from 'react'
import { useSelector } from 'react-redux';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-solid-svg-icons'

// const element = <FontAwesomeIcon icon={faUser} />

function Groupinfo() {

    const group = useSelector(state => state.room);
    const allusers = useSelector(state => state.allusers);
    console.log({ allusers });

    let all_users;
    let group_info;

    if (group.name.trim() !== '') {
        group_info = (
            <div className="group-info">
                <h2>Info : </h2>
                <h3>{group.info}</h3>
            </div>
        )
    }

    if (allusers.length > 0) {
        all_users = (
            <div className="active-users-container">
                <h2>Active Users</h2>
                {
                    allusers.map(user => (
                    <div className = "active-user-list">
                        <FontAwesomeIcon className = "user-icon" icon={faUser} />
                        <h3>{user}</h3>
                        <div class = "active-user-dot"></div>
                    </div>
                    )
                )}
            </div>
        )
    }

    return (
        <div className="group-info-container">
            <h1>{group.name}</h1>
            {group_info}
            {all_users}
        </div>
    )
}

export default Groupinfo
